module.exports = __webpack_public_path__ + "img/konfigurasi_denda_saldo_minus.463987e5.svg";